<template>
  <div class="head zoom" :style="[headFooterStyle]">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    computed: {
      headFooterStyle(){
        return this.$store.state.headFooterStyle;
      }
    },
    props: {
      logo: {
        type: [Object, String],
        default: ''
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../../assets/less/base.less';
  .head{
    position:absolute;
    left:0;
    right:0;
    top:0;
    padding: 0 50px;
    height:@head-height;
    z-index: 10;
    line-height: @head-height;
  }
</style>



// WEBPACK FOOTER //
// head.vue?3d0a8e17